<template>
    <div class="filter shadow-sm" :class="{open: open || isOpen, circles}" @click="communities = []">
        <button type="button" class="close" v-if="open || isOpen" @click="open = false;$emit('showFilter', open)">
            <span class="text-white">&times;</span>
        </button>
        <h5 class="text-white mb-0" @click="open = !open;$emit('showFilter', open)">
            <span class="d-none d-sm-inline" :class="{ 'd-inline mr-2': open || isOpen }">Filter</span>
            <i class="fa fa-filter d-inline d-sm-none"/>
            <i v-if="isFilterActive" class="fa fa-check text-success ml-3 check-icon"/>
        </h5>
        <div class="form">
            <div class="selected-chips">
                <p v-for="select in selectedCommunities" :key="select" >{{select}}<a @click="deleteCommunity(select)">&times;</a></p>
            </div>
            
            <div class="input-group mt-2 position-relative mb-2 d-flex">
                
                <div class="input-group-prepend">
                <span class="input-group-text bg-primary text-white border-light">
                    <i class="fas fa-map-marker-alt"/>
                </span>
                </div>
                <input type="text" class="form-control border-light" placeholder="Community" v-model="community" @input="search" @click="search">
                <div class="preloader" v-if="preloader">
                    <div class="dot-pulse"></div>
                </div> 
                <div class="input-group-append cursor-pointer" v-if="bookmarkButton" @click="$emit('bookmarks')">
                    <span class="input-group-text bg-primary text-white border-light book-ic" :class="{active:isBookmarks}"><i class="fa fa-bookmark"/></span>
                </div>
                <ul class="position-absolute communities" v-if="communities.length">
                    <li v-for="loc in communities" :key="loc.id" @click="selectLoc(loc)">{{loc.name}}</li>
                </ul>
            </div>
            <div class="form-group">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="latest" v-model="newOnly" @change="filter">
                    <label class="custom-control-label" for="latest">{{ translate('product_filter.latest_products') }}</label>
                </div>
            </div>
            <hr>
            <div class="form-group d-flex">
                <div class="custom-control custom-checkbox w-50">
                    <input type="checkbox" class="custom-control-input" id="levelP" v-model="pOnly" @change="productLevelChange">
                    <label class="custom-control-label" for="levelP">{{productLevels[0].name}}</label>
                </div>
                <div class="custom-control custom-checkbox w-50">
                    <input type="checkbox" class="custom-control-input" id="levelF" v-model="fOnly" @change="productLevelChange">
                    <label class="custom-control-label" for="levelF">{{productLevels[1].name}}</label>
                </div>
            </div>
            <hr>
            <div class="d-flex">
                <div class="col-6 px-0 left">
                    <div class="filter-box" v-for="item in services.slice(0, 6)" :key="item.id" @click="select(item.id)" :class="{active: selected.indexOf(item.id) !== -1}">
                        <div><i class="fas fa-shopping-bag"/></div>
                        <div>{{ item.name }}</div>
                    </div>
                </div>
                <div class="col-6 px-0 right">
                    <div class="filter-box" v-for="item in services.slice(6, 12)" :key="item.id" @click="select(item.id)" :class="{active: selected.indexOf(item.id) !== -1}">
                        <div><i class="fas fa-shopping-bag"/></div>
                        <div>{{ item.name }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { communitiesSearch,searchByName } from '../../api'

export default {
    name: 'ProductFilter',
    props: {
        isBookmarks: Boolean,
        isOpen: {
            default: false,
            type: Boolean
        },
        circles: {
            default: false,
            type: Boolean
        },
        bookmarkButton: {
            default: true,
            type: Boolean
        },
        services: {
            type: Array
        },
        productLevels: {
            type: Array
        }
    },
    data () {
        return {
            open: false,
            selected: [],
            community: '',
            communities: [],
            preloader: false,
            selectedCommunities: [],
            newOnly: false,
            pOnly: false,
            fOnly: false,
            productLevel: false
        }
    },
    methods: {
        select (id) {
            console.log('selected') 
            if (!this.selected.some(el => el === id)) {
                this.selected.push(id)
            } else {
                this.selected = this.selected.filter(el => el !== id)
            }
            
            this.filter()
        },
        async search () {
            this.preloader = true
            if (this.community !== '') {
                if(this.selectedCommunities.length) {
                    const resp = await communitiesSearch(this.community)
                    this.communities = resp.filter(el => !this.selectedCommunities.includes(el.name))
                } else {
                    this.communities = await communitiesSearch(this.community)
                }
                
                this.preloader = false
            } else {
                this.communities = []
                this.preloader = false
                this.selectLoc('')
            }
        },
        selectLoc (loc) {
            if (this.community !== '') {
                this.startSearch = false
                this.selectedCommunities.push(loc.name)
                this.communities = []
                this.filter()
            }
        },
        deleteCommunity (select) {
            this.selectedCommunities = this.selectedCommunities.filter(el => el !== select)
            this.filter()
        },
        filter() {
            this.$emit('filter', {
                service: this.selected,
                community: this.selectedCommunities,
                newOnly: this.newOnly,
                productLevel: this.productLevel
            })
        },
        productLevelChange() {
            if ((this.pOnly && this.fOnly) || (!this.pOnly && !this.fOnly)) {
                this.productLevel = false
            } else if (this.pOnly) {
                this.productLevel = '1'
            } else if (this.fOnly) {
                this.productLevel = '2'
            }
            this.filter()
        }
    },
    computed: {
        isFilterActive() {
            return this.selectedCommunities.length || this.newOnly || 
                this.productLevel.length || this.selected.length
        }
    }
}
</script>

<style scoped lang="scss">
    .filter {
        position: fixed;
        top: 70px;
        left: 2%;
        background-color: #ff9a22;
        color: #fff;
        padding: 1rem;
        border-radius: 5px;
        z-index: 2;
        max-width: 96%;
        max-height: calc(100% - 75px);

        .check-icon {
            display: inline-block;
        }

        &.circles {
            &.open {

                .form {
                    max-height: 700px;
                }
            }

            .form {

                .input-group {
                    margin-bottom: 1rem !important;
                    position: relative;
                }

                .left, .right {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                .filter-box {
                    border-radius: 50% !important;
                    border: 1px solid #fff;
                    border-top: 1px solid #fff !important;
                    height: 80px !important;
                    width: 80px !important;
                    margin-bottom: .5rem;
                    align-self: center;
                }
            }
        }

        .close {
            position: absolute;
            top: 15px;
            right: 15px;
        }

        &::-webkit-scrollbar {
            width: 3px;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background: #fff;
        }


        h5 {
            cursor: pointer;
        }

        .form {
            max-width: 0;
            max-height: 0;
            overflow: hidden;
            transition: max-width .3s, max-height .3s, padding-top .3s;

            .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
                border: 1px solid #fff;
                border-radius: .25rem;
            }

            .book-ic {
                &.active {
                    background-color: #8f4800 !important;
                }
            }

            .communities {
                width: 100%;
                top: 40px;
                color: #000;
                background-color: #fff;
                list-style-type: none;
                padding: 0;
                border-radius: 3px;
                z-index: 3;
                max-height: 360px;
                overflow-y: scroll;
                li {
                    padding: 5px 10px;
                    cursor: pointer;
                }
            }

            .left {
                .filter-box {
                    border-right: 1px solid #fff;
                    width: 100%;

                    &:first-child {
                        border-top-left-radius: 5px;
                    }

                    &:last-child {
                        border-bottom-left-radius: 5px;
                    }
                }
            }

            .right {
                .filter-box {
                    width: 100%;

                    &:first-child {
                        border-top-right-radius: 5px;
                    }

                    &:last-child {
                        border-bottom-right-radius: 5px;
                    }
                }
            }

            .filter-box {
                width: 80px;
                padding: 10px 0;
                display: flex;
                justify-content: center;
                align-items: center;
                border-top: 1px solid #fff;
                flex-direction: column;
                cursor: pointer;

                &.active {
                    background-color: #8f4800;
                }

                &:first-child {
                    border-top: none;
                }
            }
        }

        &.open {
            overflow-y: auto;

            .check-icon {
                display: none;
            }

            .form {
                padding-top: 10px;
                max-width: 500px;
                max-height: 600px;
            }
        }
    }

    @media (max-width: 768px) {
        .filter {
            top: auto;
            bottom: 2%;
        }
    }
    
    .preloader{
        position: absolute;
        left: 50%;
        top: 40%;
        transform: translate(-50%);
        z-index: 3;
    }

    .dot-pulse {
        position: relative;
        left: -9999px;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: #ff9a22;
        color: #ff9a22;
        box-shadow: 9999px 0 0 -5px #ff9a22;
        animation: dotPulse 1.5s infinite linear;
        animation-delay: .25s;
    }

    .dot-pulse::before, .dot-pulse::after {
    content: '';
        display: inline-block;
        position: absolute;
        top: 0;
        left: 0;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: #ff9a22;
        color: #ff9a22;
    }

    .dot-pulse::before {
        box-shadow: 9984px 0 0 -5px #ff9a22;
        animation: dotPulseBefore 1.5s infinite linear;
        animation-delay: 0s;
    }

    .dot-pulse::after {
        box-shadow: 10014px 0 0 -5px #ff9a22;
        animation: dotPulseAfter 1.5s infinite linear;
        animation-delay: .5s;
    }

    @keyframes dotPulseBefore {
        0% {
            box-shadow: 9984px 0 0 -5px #ff9a22;
        }
        30% {
            box-shadow: 9984px 0 0 2px #ff9a22;
        }
        60%,
        100% {
            box-shadow: 9984px 0 0 -5px #ff9a22;
        }
    }

    @keyframes dotPulse {
        0% {
            box-shadow: 9999px 0 0 -5px #ff9a22;
        }
        30% {
            box-shadow: 9999px 0 0 2px #ff9a22;
        }
        60%,
        100% {
            box-shadow: 9999px 0 0 -5px #ff9a22;
        }
    }

    @keyframes dotPulseAfter {
        0% {
            box-shadow: 10014px 0 0 -5px #ff9a22;
        }
        30% {
            box-shadow: 10014px 0 0 2px #ff9a22;
        }
        60%,
        100% {
            box-shadow: 10014px 0 0 -5px #ff9a22;
        }
    }
    .selected-chips{
        display: flex;
        max-width: 288px;
        flex-wrap: wrap;
        align-items: stretch;
        align-content: stretch;
        p{
            border-radius: 50px;
            border: 1px solid #fff;
            padding: 0 5px 0 10px;
            margin: 2px;
            a{
                margin-left: 5px;
                cursor: pointer;
            }
        }
    }
</style>
